<div (click)="select.emit()" class="flex flex-row flex-1 gap-2">
  <div class="flex flex-col gap-0 whitespace-nowrap">
    <div class="flex flex-row gap-1 text-slate-700">
      <span class="text-sm font-bold">
        {{ drugLight?.name || drug?.name || "" }}
      </span>

      @if (drug?.outOfSale) {
        <div class="rounded-md bg-slate-100 px-1 py-0.5 align-middle">
          <span class="text-xxs text-slate-600">{{
            "Fuori produzione" | transloco
          }}</span>
        </div>
      }
    </div>

    <div class="flex flex-row gap-2 items-center text-xs text-slate-400">
      <span>{{ drugLight?.unitPrice || drug?.unitPrice || 0 | money }}</span>
      -
      <span>{{ drugLight?.minsan || drug?.minsan }}</span>
      @if (drugLight?.type || drug?.type) {
        -
        <span>{{ drugLight?.type || drug?.type | transloco }}</span>
      }
      @if (drugLight?.usage || drug?.usage) {
        -
        <span>{{ drugLight?.usage || drug?.usage | transloco }}</span>
      }

      @if (drug?.tenant) {
        <div class="p-1 rounded-md bg-slate-100 text-slate-400">
          <i class="fa-light fa-user-pen"></i>
        </div>
      }
    </div>
  </div>
</div>
